import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import BlogLayer from "../../components/BlogLayer";
import CaseStudyComp from "../../components/CaseStudyComp";

const CaseStudyPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Case Study' />

        {/* BlogLayer */}
        <CaseStudyComp />
      </MasterLayout>
    </>
  );
};

export default CaseStudyPage;
